<template>
  <!-- fixed/inset-0/z-[9999] (2026-09-09): this used to be `min-h-screen
       relative`, mounted via App.vue's `v-if="hasCrashed"` as an
       ALTERNATIVE to the rest of the app (NavBar/main/footer, a Fragment
       of several sibling elements) rather than alongside it. Vue's
       hydration warns "expected Symbol(v-fgt)" whenever it must adopt a
       server-rendered snapshot at a spot where the client alternates
       between a single component and a Fragment -- App.vue now keeps
       this component always mounted (`v-show` instead of `v-if`), so it
       needs to be a true full-screen overlay to still correctly cover
       the rest of the app on an actual crash, instead of just being an
       in-flow block sitting above/beside broken content. -->
  <div class="fixed inset-0 z-[9999] flex items-center justify-center py-16 px-4 overflow-hidden bg-white">
    <div class="absolute inset-0 bg-grid-ink bg-grid-32 opacity-30 [mask-image:radial-gradient(ellipse_at_top,black_10%,transparent_65%)] pointer-events-none"></div>
    <!-- heading-tag="div": this overlay is ALWAYS mounted (v-show, see the note
         on the wrapper above) so it must never emit an <h1>. As an <h1> it put a
         hidden "Something broke" heading into the DOM of every page, ahead of the
         page's real H1 -- a live SEO defect found via a leadranks.io audit
         (h1_count=2, h1_keywords=["something broke", ...]) even though the
         overlay itself is correctly hidden. -->
    <ErrorState
      code="500"
      icon="alert-triangle"
      heading-tag="div"
      title="Something broke"
      message="An unexpected error stopped this page from working. Reloading usually fixes it — if it keeps happening, let us know."
      :detail="detail"
      primary-label="Reload Page"
      primary-icon="refresh"
      @primary="reload"
      secondary-label="Homepage"
      secondary-icon="home"
      secondary-to="/"
    />
  </div>
</template>

<script setup>
import ErrorState from '../ui/ErrorState.vue';

defineProps({
  detail: { type: String, default: '' },
});

const reload = () => window.location.reload();
</script>
